// src/Components/AdminRoute/index.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRole } from '../../Context/RoleContext';
import { useChatContext } from '../../Context/ChatContext';
import './index.css';

const AdminRoute = ({ children }) => {
  const { isAdmin, isLoading } = useRole();
  const { isAuthenticated } = useChatContext();

  // Show loading while checking role
  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-card">
          <div className="loading-spinner" aria-hidden="true" />
          <div className="loading-texts">
            <div className="loading-title">Verifying admin access…</div>
            <div className="loading-subtitle">Please wait while we check your permissions.</div>
          </div>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to home if not admin
  if (!isAdmin()) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
